import React, { useContext } from "react";

import { OperatorViewEditActivity } from "app/userManagement/modules/operator/features";
import { ProviderViewEditActivity } from "app/userManagement/modules/provider/features";

import { storageHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import constant from "lib/constant/constant";

const { userKey } = constant;
const { operator, provider } = userKey;

const ViewEditActivity = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorViewEditActivity />;
    }
    if (role === provider) {
      return <ProviderViewEditActivity />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const ViewActivityComponent = getComponent(currentUserRole);
  return ViewActivityComponent;
};

export default ViewEditActivity;
